import React from "react";
interface Props {
  data: any;
}
function Inbound({ data }: Props) {
  return (
    <div className="ubbe-card h-100">
      <div className="ubbe-card-header">
        <h5 className="ps-3 mb-0 GlobalBoxHead">Inbound</h5>
      </div>
      <div className="card-body pt-2 p-4 h-auto">
        <div className="row">
          <div className="col-md-6">
            <span className="global-text-16">Delivery Agent Name</span>
          </div>
          <div className="col-md-6 boldglobaltext text-break">
            {data?.delivery_agent_name ? data?.delivery_agent_name : "N/A"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Inbound;
